export default "__VITE_ASSET__CEnna3$O__"